import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import SimpleLine from '../ChartComponents/SimpleLine';
import {
  statisticsItemsExcelDataRequest,
  statisticsItemsListRequest
} from '../../../../redux/actions/monitoring/statisticsActions';
import { DAYS_AGO, DIFF_VALUE, SELECT_FORM_STYLE } from '../../../../constants/base';
import { itemLevel, itemType } from '../../../../constants/nft';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Notification from '../../../../components/Notification/Notification';
import BtnIcons from '../../../../api/images/btnIcons';
import { DatePicker } from '@mui/x-date-pickers';
import { convertBigNumToDecimalString } from '../../../../utils/convert-decimal-to-big-num';
import excelDownload from '../../../../api/excelDownload/excelDownload';
import sortKey from '../../../../api/excelDownload/sortKey';
import BOTable from "../../../../components/Tables/BOTable";
import useSchemaMonitoringMarket from "../../../../schema/table-schema/useSchemaMonitoringMarket";
import FetchLoading from "../../../../components/Loading/FetchLoading";
import DataItem from "../DataItem";
import {
  SearchBtnContainer,
  SearchContainer,
  SearchContent,
  SearchDateRange,
  SearchLabel,
  SearchRow
} from "../../../../components/Search/searchSection";

function items() {
  // -- component const --//
  // 아이템 타입
  const itemTypes = Object.keys(itemType).map(key => ({
    key: itemType[key],
    value: key.toString(),
  }));

  // 아이템 레벨
  const itemLevels = Object.keys(itemLevel).map(key => ({
    key: itemLevel[key],
    value: key.toString(),
  }));

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 날짜 범위
  const [activeDateRangeToken, setActiveDateRangeToken] = useState(7);

  // 데이터 설정
  const [strData, setStrData] = useState([{}]);
  const [tableData, setTableData] = useState([]);

  const [ITEMLevelTable, setITEMLevelsTable] = useState([]);
  const [ITEMTypeTable, setITEMTypesTable] = useState([]);

  const [data, setData] = useState([]);
  const [lineData, setLineData] = useState([{}]);

  const [graphType, setGraphType] = useState('count');

  const [ITEMLevel, setITEMLevels] = useState([]);
  const [ITEMType, setITEMTypes] = useState([]);

  const [startAt, setStartAt] = useState(DAYS_AGO(activeDateRangeToken));
  const [endAt, setEndAt] = useState(DAYS_AGO(1));

  const [isReset, setIsReset] = useState(false);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);

  // Excel Data
  // const [excelData, setExcelData] = useState();

  // -- func & handler --//
  const handleChange = (event, type) => {
    // 전체 선택시 빈값으로 대치
    const value = event.target.value.includes('')
      ? ['']
      : event.target.value;

    if (type === 'grade') {
      setITEMLevels(value);
    } else if (type === 'type') {
      setITEMTypes(value);
    } else if (type === 'grade-table') {
      setITEMLevelsTable(value);
    } else if (type === 'type-table') {
      setITEMTypesTable(value);
    }
  };

  const fetchList = () => {
    setIsLoadingGraph(true);

    dispatch(
      statisticsItemsListRequest({
        beginDate: startAt,
        endDate: endAt,
        itemType: ITEMType.map(item => String(item)).join(','),
        itemLevel: ITEMLevel.map(item => String(item)).join(','),
        callback: (data) => {
          console.log('요청 결과: ', data);
          setData(data?.list)

          setIsLoadingGraph(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoadingGraph(false);
        },
      })
    );

    // dispatch(
    //   statisticsItemsExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     }
    //   })
    // );

  };

  // const handleClickDownload = () => {
  //   // 파일 명 설정
  //   const fileName = `마켓_아이템_${startAt}_${endAt}`;
  //
  //   excelDownload(fileName, excelData, sortKey.statistics.market_item);
  // };

  // -- react hooks --//
  useEffect(() => {
    setStartAt(DAYS_AGO(activeDateRangeToken));
    setEndAt(DAYS_AGO(1))
  }, [activeDateRangeToken]);

  useEffect(() => {
    fetchList();

    setIsLoading(true);

    // 등록 및 거래 현황 조회
    dispatch(
      statisticsItemsListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        itemType: '',
        itemLevel: '',
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list)

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );

    // dispatch(
    //   statisticsItemsExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     }
    //   })
    // );
  }, []);

  useEffect(() => {
    setIsLoading(true);

    // 조건에 따른 등록 및 거래 현황 조회
    dispatch(
      statisticsItemsListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        itemType: ITEMTypeTable.map(item => String(item)).join(','),
        itemLevel: ITEMLevelTable.map(item => String(item)).join(','),
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, [ITEMTypeTable, ITEMLevelTable]);

  // 요청해서 온 데이터 디자인에 맞게 key 가공
  useEffect(() => {
    const updateData = data && data?.map(data => {
      // 등록
      const registerCount = data?.registerCount || 0;
      const minPrice = parseFloat(convertBigNumToDecimalString(data?.registerMinPrice, 3)) || 0;
      const maxPrice = parseFloat(convertBigNumToDecimalString(data?.registerMaxPrice, 3)) || 0;
      const registerTotalPrice = parseFloat(convertBigNumToDecimalString(data?.registerTotalPrice, 3)) || 0;
      const registerAveragePrice = (registerTotalPrice / registerCount) || 0;

      // 거래
      const transactionCount = data?.transactionCount || 0;
      const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(data?.transactionTotalPrice, 3)) || 0;
      const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
      const transactionTotalFee = parseFloat(convertBigNumToDecimalString(data?.transactionTotalFee, 3)) || 0;
      const newDate = timeFormAPI.changeDataDate(data?.targetDate);

      if (graphType === 'count') {

        return {
          '등록 수량': registerCount || 0,
          '거래 수량': transactionCount || 0,

          time: newDate
        };

      } else if (graphType === 'token') {

        return {
          '최저 등록 금액': minPrice || 0,
          '최고 등록 금액': maxPrice || 0,
          '평균 등록 금액': registerAveragePrice.toFixed(3) || 0,
          '총 거래 금액': transactionTotalPrice || 0,
          '평균 거래 금액': transactionAveragePrice.toFixed() || 0,

          time: newDate
        };

      } else if (graphType === 'fee') {

        return {
          '총 거래 수수료': transactionTotalFee || 0,

          time: newDate
        };

      }

      return {
        '등록 수량': registerCount || 0,
        '최저 등록 금액': minPrice || 0,
        '최고 등록 금액': maxPrice || 0,
        '평균 등록 금액': registerAveragePrice.toFixed(3) || 0,
        '거래 수량': transactionCount || 0,
        '총 거래 금액': transactionTotalPrice || 0,
        '평균 거래 금액': transactionAveragePrice.toFixed(3) || 0,
        '총 거래 수수료': transactionTotalFee || 0,

        time: newDate
      };
    });

    setLineData(updateData)
  }, [data]);

  useEffect(() => {
    const updateData = strData && strData.map(data => {
      // 등록
      const registerCount = data?.registerCount || 0;
      const registerMinPrice = parseFloat(convertBigNumToDecimalString(data?.registerMinPrice, 3)) || 0;
      const registerMaxPrice = parseFloat(convertBigNumToDecimalString(data?.registerMaxPrice, 3)) || 0;
      const registerTotalPrice = parseFloat(convertBigNumToDecimalString(data?.registerTotalPrice, 3)) || 0;
      const registerAveragePrice = (registerTotalPrice / registerCount) || 0;

      // 거래
      const transactionCount = data?.transactionCount || 0;
      const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(data?.transactionTotalPrice, 3)) || 0;
      const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
      const transactionTotalFee = parseFloat(convertBigNumToDecimalString(data?.transactionTotalFee, 3)) || 0;
      const targetDate = data?.targetDate;
      return {
        registerCount: registerCount,
        registerMinPrice: registerMinPrice,
        registerMaxPrice: registerMaxPrice,
        registerTotalPrice: registerTotalPrice,
        registerAveragePrice: registerAveragePrice.toFixed(3),
        transactionCount: transactionCount,
        transactionTotalPrice: transactionTotalPrice,
        transactionAveragePrice: transactionAveragePrice.toFixed(3),
        transactionTotalFee: transactionTotalFee,
        targetDate: targetDate,
      }
    });

    setTableData(updateData);
  }, [strData]);

    useEffect(() => {
        if(!isReset){
            return;
        }

        setIsReset(false);
        fetchList();

    }, [ ITEMLevel, ITEMType ])

  // -- render --//
  return (
    <>
        <div className="contentsArea">
          <div className="rowDiv">
            <div className="leftDiv" style={{width:'100%'}}>
              <div className={"contentTitle"}>
                등록 및 거래 현황 { `(${timeFormAPI.changeDataDate(DAYS_AGO(1))} 기준)` }
              </div>
            </div>

            <div className="rightDiv" style={{justifyContent: "flex-end"}}>
              <FormControl id={"formController"}>
                <Select
                    displayEmpty
                    multiple
                    value={ITEMTypeTable}
                    onChange={(event) => handleChange(event, 'type-table')}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <div style={{ color: '#999' }}>아이템 종류</div>;
                      }

                      return selected
                          .map((value) => itemTypes.find((item) => item.value === value)?.key)
                          .filter(Boolean)
                          .join(', ');
                    }}
                    style={SELECT_FORM_STYLE}
                >
                  <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                    <input
                        type="checkbox"
                        checked={ITEMTypeTable.length === itemTypes.length}
                        onChange={(event) => {
                          const checked = event.target.checked;
                          setITEMTypesTable(checked ? itemTypes.map((item) => item.value) : []);
                        }}
                    />
                    <ListItemText primary="전체 선택" />
                  </MenuItem>
                  {itemTypes.map((item) => (
                      <MenuItem
                          key={item.value}
                          value={item.value}
                          style={{
                            padding: 5,
                            gap: 5
                          }}
                      >
                        <input
                            type="checkbox"
                            checked={ITEMTypeTable.includes(item.value)}
                            onChange={(event) => {
                              const checked = event.target.checked;
                              setITEMTypesTable((prevITEMTypesTable) => {
                                if (checked) {
                                  return [...prevITEMTypesTable, item.value];
                                } else {
                                  return prevITEMTypesTable.filter((value) => value !== item.value);
                                }
                              });
                            }}
                        />
                        <ListItemText primary={item.key} />
                      </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl id={"formController"}>
                <Select
                    displayEmpty
                    multiple
                    value={ITEMLevelTable}
                    onChange={(event) => handleChange(event, 'grade-table')}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <div style={{ color: '#999' }}>아이템 레벨</div>;
                      }

                      return selected
                          .map((value) => itemLevels.find((item) => item.value === value)?.key)
                          .filter(Boolean)
                          .join(', ');
                    }}
                    style={SELECT_FORM_STYLE}
                >
                  <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                    <input
                        type="checkbox"
                        checked={ITEMLevelTable.length === itemLevels.length}
                        onChange={(event) => {
                          const checked = event.target.checked;
                          setITEMLevelsTable(checked ? itemLevels.map((item) => item.value) : []);
                        }}
                    />
                    <ListItemText primary="전체 선택" />
                  </MenuItem>
                  {itemLevels.map((item) => (
                      <MenuItem
                          key={item.value}
                          value={item.value}
                          style={{
                            padding: 5,
                            gap: 5
                          }}
                      >
                        <input
                            type="checkbox"
                            checked={ITEMLevelTable.includes(item.value)}
                            onChange={(event) => {
                              const checked = event.target.checked;
                              setITEMLevelsTable((prevITEMLevelsTable) => {
                                if (checked) {
                                  return [...prevITEMLevelsTable, item.value];
                                } else {
                                  return prevITEMLevelsTable.filter((value) => value !== item.value);
                                }
                              });
                            }}
                        />
                        <ListItemText primary={item.key} />
                      </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>

          {
            isLoading ? (
                <FetchLoading/>
              )
              :
                tableData.length <= 0 ?
                <>
                    정보를 불러올 수 없습니다.
                </>
                : tableData.slice(0, -1).map((data, index) => (

                <div key={index} style={{padding: "10px 15px"}}>
                  <div className="rowDiv" >
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%'
                    }}>
                      <div style={{ display: 'flex', gap: 5 }}>
                        <DataItem
                            label="등록 수량"
                            value={tableData[index + 1]?.registerCount}
                            prevValue={tableData[index]?.registerCount}
                            targetDate={tableData[index + 1]?.targetDate}
                        />

                        <DataItem
                            label="최저 등록 금액"
                            value={tableData[index + 1]?.registerMinPrice}
                            prevValue={tableData[index]?.registerMinPrice}
                            targetDate={tableData[index + 1]?.targetDate}
                        />

                        <DataItem
                            label="최고 등록 금액"
                            value={tableData[index + 1]?.registerMaxPrice}
                            prevValue={tableData[index]?.registerMaxPrice}
                            targetDate={tableData[index + 1]?.targetDate}
                        />

                        <DataItem
                            label="평균 등록 금액"
                            value={tableData[index + 1]?.registerAveragePrice}
                            prevValue={tableData[index]?.registerAveragePrice}
                            targetDate={tableData[index + 1]?.targetDate}
                        />
                      </div>

                    </div>
                  </div>

                  <div className="spaceDiv10"/>
                  <div className="spaceDiv10"/>

                  <div className="rowDiv">

                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%'
                    }}>
                      <div style={{ display: 'flex', gap: 5 }}>
                        <DataItem
                            label="거래 수량"
                            value={tableData[index + 1]?.transactionCount}
                            prevValue={tableData[index]?.transactionCount}
                            targetDate={tableData[index + 1]?.targetDate}
                        />

                        <DataItem
                            label="총 거래 금액"
                            value={tableData[index + 1]?.transactionTotalPrice}
                            prevValue={tableData[index]?.transactionTotalPrice}
                            targetDate={tableData[index + 1]?.targetDate}
                        />

                        <DataItem
                            label="평균 거래 금액"
                            value={tableData[index + 1]?.transactionAveragePrice}
                            prevValue={tableData[index]?.transactionAveragePrice}
                            targetDate={tableData[index + 1]?.targetDate}
                        />

                        <DataItem
                            label="총 거래 수수료"
                            value={tableData[index + 1]?.transactionTotalFee}
                            prevValue={tableData[index]?.transactionTotalFee}
                            targetDate={tableData[index + 1]?.targetDate}
                        />
                      </div>

                    </div>
                  </div>
                </div>

              ))
          }


        </div>


      <div className="spaceDiv10"/>

      <SearchContainer>
        <SearchRow>
          <SearchLabel text={"날짜"}/>
          <SearchDateRange
              startAt={startAt}
              endAt={endAt}
              setStartAt={setStartAt}
              setEndAt={setEndAt}
          />
        </SearchRow>

        <SearchRow>
          <SearchLabel text={"아이템 종류"}/>
          <SearchContent>
            <FormControl id={'formController'}>
              <Select
                  displayEmpty
                  multiple
                  value={ITEMType}
                  onChange={(event) => handleChange(event, 'type')}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>아이템 종류</div>;
                    }

                    return selected
                        .map((value) => itemTypes.find((item) => item.value === value)?.key)
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{
                  padding: 5,
                  gap: 5
                }}>
                  <input
                      type="checkbox"
                      checked={ITEMType.length === itemTypes.length}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setITEMTypes(checked ? itemTypes.map((item) => item.value) : []);
                      }}
                  />
                  <ListItemText primary="전체 선택"/>
                </MenuItem>
                {itemTypes.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        style={{
                          padding: 5,
                          gap: 5
                        }}
                    >
                      <input
                          type="checkbox"
                          checked={ITEMType.includes(item.value)}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setITEMTypes((prevITEMTypes) => {
                              if (checked) {
                                return [...prevITEMTypes, item.value];
                              } else {
                                return prevITEMTypes.filter((value) => value !== item.value);
                              }
                            });
                          }}
                      />
                      <ListItemText primary={item.key}/>
                    </MenuItem>
                ))}
              </Select>
            </FormControl>


          </SearchContent>

          <SearchLabel text={"아이템 레벨"}/>
          <SearchContent>
            <FormControl id={'formController'}>
              <Select
                  displayEmpty
                  multiple
                  value={ITEMLevel}
                  onChange={(event) => handleChange(event, 'grade')}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>아이템 레벨</div>;
                    }

                    return selected
                        .map((value) => itemLevels.find((item) => item.value === value)?.key)
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{
                  padding: 5,
                  gap: 5
                }}>
                  <input
                      type="checkbox"
                      checked={ITEMLevel.length === itemLevels.length}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setITEMLevels(checked ? itemLevels.map((item) => item.value) : []);
                      }}
                  />
                  <ListItemText primary="전체 선택"/>
                </MenuItem>
                {itemLevels.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        style={{
                          padding: 5,
                          gap: 5
                        }}
                    >
                      <input
                          type="checkbox"
                          checked={ITEMLevel.includes(item.value)}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setITEMLevels((prevITEMLevels) => {
                              if (checked) {
                                return [...prevITEMLevels, item.value];
                              } else {
                                return prevITEMLevels.filter((value) => value !== item.value);
                              }
                            });
                          }}
                      />
                      <ListItemText primary={item.key}/>
                    </MenuItem>
                ))}
              </Select>
            </FormControl>

          </SearchContent>
        </SearchRow>

      </SearchContainer>

        <SearchBtnContainer
            handleSearchClick={() => {
                fetchList();
            }}
            handleResetClick={() => {
                setITEMLevels([]);
                setITEMTypes([]);
                setStartAt(DAYS_AGO(activeDateRangeToken));
                setEndAt(DAYS_AGO(1));

                setIsReset(true);
            }}
        />

      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        등록 및 거래 내역 조회*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className="spaceDiv10"/>*/}
      {/*    <div className="descDiv" style={{ alignItems: 'center' }}>*/}

      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={ITEMType}*/}
      {/*          onChange={(event) => handleChange(event, 'type')}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>아이템 종류</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map((value) => itemTypes.find((item) => item.value === value)?.key)*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem value="all" style={{*/}
      {/*            padding: 5,*/}
      {/*            gap: 5*/}
      {/*          }}>*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={ITEMType.length === itemTypes.length}*/}
      {/*              onChange={(event) => {*/}
      {/*                const checked = event.target.checked;*/}
      {/*                setITEMTypes(checked ? itemTypes.map((item) => item.value) : []);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText primary="전체 선택"/>*/}
      {/*          </MenuItem>*/}
      {/*          {itemTypes.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item.value}*/}
      {/*              value={item.value}*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={ITEMType.includes(item.value)}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setITEMTypes((prevITEMTypes) => {*/}
      {/*                    if (checked) {*/}
      {/*                      return [...prevITEMTypes, item.value];*/}
      {/*                    } else {*/}
      {/*                      return prevITEMTypes.filter((value) => value !== item.value);*/}
      {/*                    }*/}
      {/*                  });*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary={item.key}/>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={ITEMLevel}*/}
      {/*          onChange={(event) => handleChange(event, 'grade')}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>아이템 레벨</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map((value) => itemLevels.find((item) => item.value === value)?.key)*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem value="all" style={{*/}
      {/*            padding: 5,*/}
      {/*            gap: 5*/}
      {/*          }}>*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={ITEMLevel.length === itemLevels.length}*/}
      {/*              onChange={(event) => {*/}
      {/*                const checked = event.target.checked;*/}
      {/*                setITEMLevels(checked ? itemLevels.map((item) => item.value) : []);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText primary="전체 선택"/>*/}
      {/*          </MenuItem>*/}
      {/*          {itemLevels.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item.value}*/}
      {/*              value={item.value}*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={ITEMLevel.includes(item.value)}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setITEMLevels((prevITEMLevels) => {*/}
      {/*                    if (checked) {*/}
      {/*                      return [...prevITEMLevels, item.value];*/}
      {/*                    } else {*/}
      {/*                      return prevITEMLevels.filter((value) => value !== item.value);*/}
      {/*                    }*/}
      {/*                  });*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary={item.key}/>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*      <div className="descDiv dateSmall">*/}
      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setStartAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={startAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setEndAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={endAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*      </div>*/}

      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 7 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(7);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        주*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 30 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(30);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        월*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 90 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(90);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        3개월*/}
      {/*      </button>*/}

      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'count' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('count');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        수량*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'token' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('token');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        금액*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'fee' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('fee');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        수수료*/}
      {/*      </button>*/}

      {/*      <button className="defaultBtn"*/}
      {/*              onClick={() => {*/}
      {/*                // handleSearchClick;*/}
      {/*                fetchList();*/}
      {/*              }}*/}
      {/*      >*/}
      {/*        조회*/}
      {/*      </button>*/}

      {/*      /!*<button className="defaultBtn fit purple" onClick={handleClickDownload}>*!/*/}
      {/*      /!*  <img src={BtnIcons.downloadIcon} alt={'다운로드'}/>*!/*/}
      {/*      /!*  엑셀 다운로드*!/*/}
      {/*      /!*</button>*!/*/}

      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className="spaceDiv10"/>*/}

      {/*  /!*{*!/*/}
      {/*  /!*  isLoadingGraph ? (*!/*/}
      {/*  /!*      <div className="rowDiv" style={{*!/*/}
      {/*  /!*        width: '100%',*!/*/}
      {/*  /!*        height: 520,*!/*/}
      {/*  /!*        display: 'flex',*!/*/}
      {/*  /!*        justifyContent: 'center',*!/*/}
      {/*  /!*        padding: 'unset'*!/*/}
      {/*  /!*      }}>*!/*/}
      {/*  /!*        Loading...*!/*/}
      {/*  /!*      </div>*!/*/}
      {/*  /!*    )*!/*/}
      {/*  /!*    : <div className="rowDiv" style={{*!/*/}
      {/*  /!*  height: 520,*!/*/}
      {/*  /!*  padding: 'unset'*!/*/}
      {/*  /!*}}>*!/*/}
      {/*  /!*  <div className="descDiv" style={{*!/*/}
      {/*  /!*    width: '100%',*!/*/}
      {/*  /!*    height: '100%'*!/*/}
      {/*  /!*  }}>*!/*/}
      {/*  /!*    <SimpleLine data={lineData}/>*!/*/}
      {/*  /!*  </div>*!/*/}
      {/*  /!*</div>*!/*/}
      {/*  /!*}*!/*/}
      {/*</div>*/}

      <div className="spaceDiv10"/>

      <BOTable
          rows={data}
          schema={useSchemaMonitoringMarket()}
          loading={isLoadingGraph}
          maxHeight={"60vh"}
      />

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </>
  );
}

export default items;
